import React, { useState } from "react";
import { Modal, Button, Input } from "antd";
import { useQueryClient } from "react-query";
import toast from "react-hot-toast";
import "../utils/validate.css";
import { activeMerchant, deactiveMerchant } from "../services/merchentApi";
import defaultAvatar from "../../../../assets/images/default-avatar.png";
const ManageMerchent = ({ modal, setModal, toggle, selectedMerchent, mode = "validate",onSuccess }) => {
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  const isValidateMode = mode === "validate";
 const handleAction = async () => {

  // 🔴 Motif obligatoire si désactivation
  if (!isValidateMode && !reason?.trim()) {
    toast.error("Le motif de désactivation du marchand est obligatoire");
    return;
  }

  setIsLoadingSubmit(true);

  try {
    if (isValidateMode) {
      await activeMerchant(selectedMerchent?.id);
      toast.success("Le marchand a été activé avec succès");
    } else {
      await deactiveMerchant(selectedMerchent?.id, reason);
      toast.success("Le marchand a été désactivé avec succès");
    }

    if (onSuccess) {
      await onSuccess();
    }

    setModal(false);

  } catch (error) {
    toast.error(`Erreur : ${error?.message || error}`);
  } finally {
    setIsLoadingSubmit(false);
  }
};
const [reason, setReason] = useState("");
  return (
    <Modal
      open={modal}
      onCancel={toggle}
      footer={null}
      centered
      width={450}
      className="modal-validate"
    >
      <div className="validate-modal-content">
        <h2 className="validate-title">
          {isValidateMode
            ? `Activer le compte du marchand ? `
            : `Désactiver le compte du marchand ? `}
        </h2>
        <div className="validate-merchent mb-3">
          {isValidateMode
          ? `L’activation du compte rendra le marchand actif sur la plateforme Paxity. Il pourra recevoir des commandes et accéder à son tableau de bord. `
          : `La désactivation du compte rendra le marchand inactif sur la plateforme Paxity. 
          Il ne pourra plus recevoir de commandes ni accéder à son tableau de bord tant que le compte n’est pas réactivé`}
          </div>
             <div style={{display: "flex",justifyContent: "center",alignItems: "center" }}>
                  <img
                    src={selectedMerchent?.profilePhoto ||defaultAvatar}
                       alt={`${selectedMerchent.firstName} ${selectedMerchent.lastName}`}
                        style={{
                            width: 46,
                            height: 46,
                            borderRadius: "50%",
                            objectFit: "cover"
                        }}
                        />
                        </div>
                    
        < span className="merchent">{selectedMerchent?.firstName} {selectedMerchent?.lastName}</span>
        <div className="merchente">Marchand</div>
        {/*<div className="validate-animation">
          <Lottie
            animationData={isValidateMode ? validateAnimation : warningAnimation}
            style={{ height: 180 }}
            loop
          />
        </div> */}
        
        <div className="validate-description">
          {isValidateMode ? (
            <>
              <p>Êtes-vous sûr de vouloir activer ce marchant ?</p>
            </>
          ) : (
           <>
      <p>Voulez-vous vraiment désactiver ce marchand ?</p>
      
      <div style={{ marginTop: "15px" }}>
        <label style={{ fontWeight: 400 ,fontSize:'13px',fontFamily:'Poppins',color:'#6A6A6A',display:'flex',textAlign:'left'}}>Motif de désactivation</label>
        <Input.TextArea
          placeholder="Message au marchand (sera envoyé par email)."
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          rows={4}
          style={{ marginTop: "6px", borderRadius: "8px",fontWeight: 400 ,fontSize:'13px',fontFamily:'Poppins',color:'#B7B7B7' }}
        />
      </div>
      </>
          )}
        </div>
        <div className="validate-footer mb-2">
        <button
        style={{
                  backgroundColor: isValidateMode ? " #EBFFEA" : " #FFF0F0",
                  color: isValidateMode ? " #349C32 " : " #D41C1C",
                  padding: "5px 12px",
                  fontFamily: "Poppins",
                  fontWeight: 400,
                  fontSize: "14px",
                  borderRadius: "8px",
                  border: "none",
                  outline: "none",
                  cursor: "pointer",
                  width:"80%"
                }}
            onClick={handleAction}
            loading={isLoadingSubmit}
          >
            {isLoadingSubmit
              ? isValidateMode
                ? "Validation en cours..."
                : "Désactivation..."
              : isValidateMode
                ? "Confirmer l'activation"
                : "Confirmer la désactivation"}
          </button>
          </div>
           <button
           style={{
                  backgroundColor:'#F3F3F3',
                  color: '#000000',
                  padding: "5px 12px",
                  fontFamily: "Poppins",
                  fontWeight: 400,
                  fontSize: "14px",
                  borderRadius: "8px",
                  border: "none",
                  outline: "none",
                  cursor: "pointer",
                  width:"80%"
                }}
           onClick={() => setModal(false)} disabled={isLoadingSubmit}>
            Annuler
          </button>
      </div>
    </Modal>
  );
};

export default ManageMerchent;
